import type { Uploader, UploadResult } from '@buffer-mono/uploader'
import { UploadSource } from '@buffer-mono/uploader'

import { CanvaLiterals } from './constants'

export const uploadCanvaDesign = (
  designId: string,
  remoteUrl: string,
  uploader: Pick<Uploader, 'addFilesFromUrls'>,
): Promise<UploadResult> => {
  return uploader.addFilesFromUrls(
    [
      {
        remoteUrl,
        name: CanvaLiterals.CanvaFilename,
      },
    ],
    {
      source: UploadSource.canva(designId),
    },
  )
}
